import { colors } from "#app/theme/v1/colors";
import { fontSizes } from "#app/theme/v1/fontSizes";
import { Group } from "#shared/view/components/Group";
import { Stack } from "#shared/view/components/Stack";
import { Text } from "#shared/view/components/Text";
import { UnstyledButton } from "#shared/view/designSystem/UnstyledButton";

export const AnalyzeError = ({
  retryAction,
  retryText,
  errorText,
  secondaryRetryAction,
  secondaryRetryText,
  justify = "end",
}: {
  retryAction: () => void;
  retryText: string;
  errorText: string;
  secondaryRetryAction?: () => void;
  secondaryRetryText?: string;
  justify?: "start" | "end";
}) => {
  return (
    <Stack justify={"center"} gap="0">
      <Text fz="xs" c="red">
        {errorText}
      </Text>

      <Group gap="xxs" justify={justify}>
        <UnstyledButton
          color="dimmed"
          style={{
            textDecoration: "underline",
            color: colors.gray[4],
            fontSize: fontSizes.tiny,
          }}
          onClick={retryAction}
        >
          {retryText}
        </UnstyledButton>

        {secondaryRetryAction && secondaryRetryText && (
          <>
            <Text c={colors.gray[5]}>ou</Text>
            <UnstyledButton
              color="dimmed"
              style={{
                textDecoration: "underline",
                color: colors.gray[4],
                fontSize: fontSizes.tiny,
              }}
              onClick={secondaryRetryAction}
            >
              {secondaryRetryText}
            </UnstyledButton>
          </>
        )}
      </Group>
    </Stack>
  );
};
